import {observer} from "mobx-react";
import {Component} from "preact";
import {connection} from "../model";
import {resources} from "../resources";
import {classNames} from "./classNames";
import style from "./ConnectionView.module.css";
import {Icon} from "./controls/Icon";
import {Spinner} from "./controls/Spinner";

export const ConnectionView = observer(
	class ConnectionView extends Component {
		render() {
			return (
				<div
					class={classNames(
						style.connectionView,
						connection.pending && style.pending,
						connection.online && style.online,
						connection.offline && style.offline,
					)}
				>
					{connection.pending && [
						<Spinner class={style.icon} />,
						<div class={style.text}>{resources.strings.ConnectionPending}</div>,
					]}
					{connection.offline && [
						<Icon class={style.icon}>error</Icon>,
						<div class={style.text}>{resources.strings.ConnectionOffline}</div>,
						<button class={style.retryButton} onClick={this.handleRetryClick}>
							{resources.strings.ConnectionRetry}
						</button>,
					]}
					{connection.online && [
						<Icon class={style.icon}>check_circle</Icon>,
						<div class={style.text}>{resources.strings.ConnectionOnline}</div>,
					]}
				</div>
			);
		}

		private handleRetryClick = () => connection.connect();
	},
);
